﻿<template>
    <div id="calendar" class="sc-cal tour-calendar">

        <div class="sc-cal-head">
            <span class="sc-cal-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>
            </span>
            <div>
                <h2 class="sc-cal-title">{{ isRange() ? 'Choose your travel dates' : 'Choose a travel date' }}</h2>
                <p class="sc-cal-intro">{{ isRange() ? 'Pick a start and an end date, then apply to show the tours departing in between.' : 'Pick a date to see the tours departing that day.' }}</p>
            </div>
        </div>

        <div class="custom-calendar">
            <calendar_month :selected_month=selected_month :months="months" @monthChange="onMonthChange" ref="calendar_month"></calendar_month>
            <calendar_details @dateSelected="Date_Selected" @rangeChange="onRangeChange" ref="calendar_details"></calendar_details>
        </div>

        <!-- date range mode (VITE_DEFAULT_SEARCH_DATE_RANGE): apply the selected range as a filter on the search results -->
        <div v-if="isRange()" class="sc-cal-bar">
            <p class="sc-cal-range" :class="{ 'is-empty': range_label() == '' }">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>
                <span v-if="range_label() != ''">{{ range_label() }}</span>
                <span v-else>No dates selected</span>
            </p>
            <div class="sc-cal-actions">
                <button v-if="range_label() != '' || range_applied" type="button" class="sc-cal-clear" @click="Clear_Range()">Clear</button>
                <button type="button" class="button button-pink-book sc-cal-apply" :disabled="(range_from.output_date ?? '') == ''" @click="Apply_Chanages()">Apply dates</button>
            </div>
        </div>
    </div>

    <div class="slideout" :class="{'active': isTourListOpen, 'hidden': !isTourListOpen}"
         x-transition:enter="transition ease-out duration-500 -mr-64"
         x-transition:enter-start=""
         x-transition:enter-end="transform -translate-x-64"
         x-transition:leave="transform ease-out duration-75"
         x-transition:leave-start=""
         x-transition:leave-end="transform translate-x-64">
        <div class="slideout-inner sc-slideout">
            <button class="close no-bg" aria-label="Close" @click="isTourListOpen = false"></button>

            <tour_list :tours_selected="tours_selected" :travel_date="travel_date" @tourSelected="Tour_Selected"></tour_list>
        </div>

        <div class="slideout-bg" @click="isTourListOpen = false"></div>

    </div>

</template>

<script lang="ts" src="./calendar.ts"></script>